// Supplemental regions — proper display names for region slugs that appear in the
// sitemap and have live pages but are not yet in the main REGIONS catalogue. Without
// these, getRegionBySlug() returns the "All Regions" sentinel, the Search Identity
// Engine cannot resolve the geography, and the Identity Validator FAILs the page with
// UNKNOWN_REGION (a fake geographic identity must never ship). Each entry resolves one.
//
// slug matches the LIVE URL slug; `name` carries the correct proper spelling + diacritics.
// Sourced from the UNKNOWN_REGION exceptions queue (Ubersuggest/dist audit, 2026-07-22).
// (The invalid route /italy/italy is intentionally NOT listed — it is handled as noindex.)

export const SUPPLEMENTAL_REGIONS = [
  // England
  { slug: 'north-yorkshire', name: 'North Yorkshire', countrySlug: 'england' },
  { slug: 'west-sussex',     name: 'West Sussex',     countrySlug: 'england' },
  { slug: 'east-sussex',     name: 'East Sussex',     countrySlug: 'england' },
  { slug: 'county-durham',   name: 'County Durham',   countrySlug: 'england' },
  // Scotland
  { slug: 'aberdeenshire',   name: 'Aberdeenshire',   countrySlug: 'scotland' },
  { slug: 'east-lothian',    name: 'East Lothian',    countrySlug: 'scotland' },
  { slug: 'midlothian',      name: 'Midlothian',      countrySlug: 'scotland' },
  // Ireland / Northern Ireland
  { slug: 'county-limerick', name: 'County Limerick', countrySlug: 'ireland' },
  { slug: 'county-down',     name: 'County Down',     countrySlug: 'northern-ireland' },
  // France
  { slug: 'french-riviera',  name: 'French Riviera',  countrySlug: 'france' },
  { slug: 'arcachon-bay',    name: 'Arcachon Bay',    countrySlug: 'france' },
  { slug: 'ile-de-france',   name: 'Île-de-France',   countrySlug: 'france' },
  // Spain
  { slug: 'balearic-islands', name: 'Balearic Islands', countrySlug: 'spain' },
  { slug: 'tenerife',        name: 'Tenerife',        countrySlug: 'spain' },
  // Switzerland
  { slug: 'lake-lucerne',    name: 'Lake Lucerne',    countrySlug: 'switzerland' },
  { slug: 'geneva',          name: 'Geneva',          countrySlug: 'switzerland' },
  { slug: 'obwalden',        name: 'Obwalden',        countrySlug: 'switzerland' },
  { slug: 'vaud',            name: 'Vaud',            countrySlug: 'switzerland' },
  // Greece
  { slug: 'attica',          name: 'Attica',          countrySlug: 'greece' },
  { slug: 'cyclades',        name: 'Cyclades',        countrySlug: 'greece' },
  // Italy handled in main catalogue; the invalid /italy/italy route is noindexed, not listed.
  // Portugal / Poland / Czechia / Slovenia
  { slug: 'centro',          name: 'Centro',          countrySlug: 'portugal' },
  { slug: 'west-pomerania',  name: 'West Pomerania',  countrySlug: 'poland' },
  { slug: 'central-bohemia', name: 'Central Bohemia', countrySlug: 'czech-republic' },
  { slug: 'upper-carniola',  name: 'Upper Carniola',  countrySlug: 'slovenia' },
  { slug: 'gorenjska',       name: 'Gorenjska',       countrySlug: 'slovenia' },
  // Montenegro
  { slug: 'budva-riviera',   name: 'Budva Riviera',   countrySlug: 'montenegro' },
  { slug: 'lustica-bay',     name: 'Luštica Bay',     countrySlug: 'montenegro' },
  // Morocco
  { slug: 'marrakech-safi',  name: 'Marrakech-Safi',  countrySlug: 'morocco' },
  { slug: 'draa-valley',     name: 'Draa Valley',     countrySlug: 'morocco' },
  // Turkey
  { slug: 'mugla',           name: 'Muğla',           countrySlug: 'turkey' },
  // Mexico / Caribbean / Central America
  { slug: 'riviera-nayarit', name: 'Riviera Nayarit', countrySlug: 'mexico' },
  { slug: 'stann-creek',     name: 'Stann Creek',     countrySlug: 'belize' },
  { slug: 'tortola',         name: 'Tortola',         countrySlug: 'british-virgin-islands' },
  { slug: 'guanacaste',      name: 'Guanacaste',      countrySlug: 'costa-rica' },
  { slug: 'manuel-antonio',  name: 'Manuel Antonio',  countrySlug: 'costa-rica' },
  { slug: 'castries',        name: 'Castries',        countrySlug: 'st-lucia' },
  { slug: 'grenadines',      name: 'Grenadines',      countrySlug: 'st-vincent-and-the-grenadines' },
  { slug: 'st-james',        name: 'Saint James',     countrySlug: 'jamaica' },
  // Asia-Pacific
  { slug: 'bali',            name: 'Bali',            countrySlug: 'indonesia' },
  { slug: 'preah-sihanouk',  name: 'Preah Sihanouk',  countrySlug: 'cambodia' },
  { slug: 'pahang',          name: 'Pahang',          countrySlug: 'malaysia' },
  { slug: 'terengganu',      name: 'Terengganu',      countrySlug: 'malaysia' },
  { slug: 'laamu-atoll',     name: 'Laamu Atoll',     countrySlug: 'maldives' },
  { slug: 'south-male-atoll', name: 'South Malé Atoll', countrySlug: 'maldives' },
  // Middle East / Africa
  { slug: 'tabuk',           name: 'Tabuk',           countrySlug: 'saudi-arabia' },
  { slug: 'hermanus',        name: 'Hermanus',        countrySlug: 'south-africa' },
  // Gibraltar (city-state region == country)
  { slug: 'gibraltar',       name: 'Gibraltar',       countrySlug: 'gibraltar' },
];
